<template>
    <h5>Alta de canal</h5>
    <Form role="form" class="card-empirulada q-pad q-mar-top" :validation-schema="schema" @submit="handleAltaCanal">

        <soft-field type="text" id="nombre" v-model="canal.nombre" :useLabel="true" label="Nombre" name="nombre" class="mb-2 label-input2" largo="80"/>

        <soft-select v-if="miRol==1" id="tipsterid" v-model="canal.tipsterid" name="tipsterid" :valores="tipsters" :useLabel="true" label="Tipster" class="mb-2 label-select2"/>

        <p style="font-size:13px;margin-top:12px;"><b>NOTA:</b> Tras el alta deberá poner al bot <b>{{ botName }}</b> como administrador de su grupo de Telegram y ejecutar el comando <b>/initCanal</b> con el código generado tras el alta</p>
        <div class="q-flex-between q-mar-top">
            <button
                type="button"
                class="btn-q-secondary"
                @click="$emit('cerrar-modal')"
                >
                Volver
            </button>

            <button
                type="submit"
                class="btn-q-primary"
                :disabled="loading">
                <span v-if="loading" class="spinner-border spinner-border-sm"></span>
                <span v-else>Confirmar</span>
            </button>
        </div> 
    </Form>
</template>
  
<script>
  import SoftField from "@/components/SoftField.vue";
  import SoftSelect from "@/components/SoftSelect.vue";
  import showSwal from "/src/mixins/showSwal.js";
  import { Form } from "vee-validate";
  import * as yup from "yup";

  export default {
    name: "AltaCanalForm",
    components: {
        SoftField,
        SoftSelect,
        Form,
    },
    props: {
        canalBotName: String,
    },
    data() {
        const schema = yup.object().shape({
            nombre: yup.string().required("El nombre es necesario!").max(80,'El tamaño máximo es de 80 caracteres'),
        });

        const miRol = this.$store.getters["auth/rolEfectivo"];
        var roles = [ {id:1,nombre:'Administrador'}, {id:2,nombre:'Admin.Tipster'}, {id:3,nombre:'Cliente'}];
        if (miRol==2) {
            roles = [ {id:2,nombre:'Admin.Tipster'}, {id:3,nombre:'Cliente'}];
        }
        
        return {
            loading: false,
            canal:{
                nombre: '',
                tipsterid: miRol==2 ? localStorage.getItem("usuarioTipsterId") : null
            },
            schema,
            roles: roles,
            tipsters: [],
            miRol: miRol,
            botName: this.canalBotName
        };
    },
    emits: ['cerrar-modal'],
    methods: {
      async handleAltaCanal() {
        // Aquí puedes realizar acciones cuando se envía el formulario
        this.loading = true;
        try {
            const resp = await this.$store.dispatch("auth/guardaCanal", this.canal);
            this.loading = false;
            if (resp.res=='OK') {
                showSwal.methods.showSwal({
                    type: "success",
                    message: "Se ha registrado el nuevo canal. Indique /initCanal " + resp.uuid + " en su canal privado de Telegram para empezar a operar",
                    width: 600,
                    timer: 10000
                });
                this.$emit('cerrar-modal');
            }
            else {
                showSwal.methods.showSwal({
                    type: "error",
                    message: resp.mensaje,
                    width: 500
                });               
            }
        } catch (error) {
            this.loading = false;
            showSwal.methods.showSwal({
                type: "error",
                message: error.response?.data?.mensaje || "Se ha producido un error",
                width: 500,
            });
        }
      },
    },
    async mounted() {
        if (this.miRol === 1) {
            this.tipsters = await this.$store.dispatch("auth/listaTipsters");
        }
    },
  };
  </script>
  
  <style scoped>
 /* ===== CONTENEDOR BOTONES ===== */

.q-flex-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1.5rem;
}

/* ===== BOTONES ===== */

.btn-q-primary,
.btn-q-secondary {
    min-width: 180px;
    height: 48px;
    padding: 0 24px;
    font-size: 1rem;
    font-weight: 600;
    border-radius: 10px;
    border: none;
    cursor: pointer;
}

.btn-q-primary {
    background: var(--q-gold);
    color: var(--q-gold-on);
}

.btn-q-primary:hover {
    background: var(--q-gold-hover);
}

.btn-q-secondary {
    background: var(--q-hover);
    color: var(--q-text);
}

.btn-q-secondary:hover {
    background: var(--q-border-md);
}

/* ===== RESPONSIVE ===== */

@media (max-width: 768px) {

    .q-flex-between {
        flex-direction: column !important;
        gap: 1rem !important;
    }

    .btn-q-primary,
    .btn-q-secondary {
        width: 100% !important;
        min-width: unset !important;
    }
}
  </style>